import React from "react"
import RichTextConnector from "../RichText/RichTextConnector"
import renderPaddingOrFullBleed from "../../utils/organism-formatting/renderPaddingOrFullBleed"
import formatIcons from "../../utils/organism-formatting/formatIcons"
import formatLottieAnimation from "../../utils/organism-formatting/formatLottieAnimation"
import { TwoByTwo } from "terra-one"

const typeNameMap = {
  ContentfulHeader: "Header",
  ContentfulRichTextContent: "Rich Text",
  ContentfulImageWithFocalPoint: "Image",
  ContentfulDataPoint: "Data Point",
  ContentfulStatContentBlock: "Stat",
  ContentfulLottieAnimation: "Lottie Animation",
}

const TwoByTwoConnector = props => {
  let overrideForStat
  const { data, location, isNested } = props
  const backgroundImages =
    data?.backgroundImages?.map(item => {
      if (item.__typename === "ContentfulLottieAnimation") {
        let twoByTwoLottieStyles = {
          height: "100%",
          width: "100%",
        }
        let ratio = {
          height: 3,
          width: 4,
        }
        return formatLottieAnimation(
          item?.srcLink || item?.json?.data,
          twoByTwoLottieStyles,
          ratio
        )
      } else {
        return {
          focalPointImage: {
            title: item?.altText,
            url: item?.image?.file?.url,
          },
        }
      }
    }) || []

  const topLeftBackgroundColor = props?.productPage
    ? "dark-navy"
    : data?.topLeftBackgroundColor?.split(" ").join("-").toLowerCase() ||
      "white"
  const topRightBackgroundColor =
    data?.topRightBackgroundColor?.split(" ").join("-").toLowerCase() || "white"
  const bottomLeftBackgroundColor =
    data?.bottomLeftBackgroundColor?.split(" ").join("-").toLowerCase() ||
    "white"
  const bottomRightBackgroundColor = props?.productPage
    ? "dark-navy"
    : data?.bottomRightBackgroundColor?.split(" ").join("-").toLowerCase() ||
      "white"

  const parseContent = (item, backgroundColor) => {
    if (item?.__typename === "ContentfulLottieAnimation") {
      let ratio = {
        height: 3,
        width: 4,
      }
      return formatLottieAnimation(
        item?.srcLink || item?.json?.data,
        item?.style,
        ratio
      )
    }
    if (item?.__typename === "ContentfulStatContentBlock") {
      overrideForStat = true
    }
    let backgroundTheme = "transparent-light-text"

    if (backgroundColor === "white" || backgroundColor === "concrete-gray") {
      backgroundTheme = "transparent-dark-text"
    }
    return {
      type: item?.__typename ? typeNameMap[item.__typename] : null,
      url: item?.url,
      ...item,
      content:
        item?.__typename === "ContentfulRichTextContent" ? (
          <RichTextConnector
            data={{ ...item, parentColorScheme: backgroundTheme }}
            location={location}
          />
        ) : item?.__typename === "ContentfulStatContentBlock" ? (
          {
            stat: item?.statInformation,
            subheader: item?.subheader,
            text: item?.text,
          }
        ) : null,
      focalPointImage: {
        title: item?.altText,
        url: item?.image?.file?.url,
      },
      points: item?.points?.map(point => {
        return {
          contentfulId: point?.contentfulId,
          header: point?.header,
          description: point?.description,
          icon: { type: formatIcons(point?.dataPointIcon?.icon) },
        }
      }),
    }
  }

  const topLeftContent = data?.topLeftContent?.map(item =>
    parseContent(item, topLeftBackgroundColor)
  )
  const topRightContent = data?.topRightContent?.map(item =>
    parseContent(item, topRightBackgroundColor)
  )
  const bottomLeftContent = data?.bottomLeftContent?.map(item =>
    parseContent(item, bottomLeftBackgroundColor)
  )
  const bottomRightContent = data?.bottomRightContent?.map(item =>
    parseContent(item, bottomRightBackgroundColor)
  )

  const topLeftIsImage = topLeftContent?.some(item => item.type === "Image")
  const topRightIsImage = topRightContent?.some(item => item.type === "Image")
  const bottomLeftIsImage = bottomLeftContent?.some(
    item => item.type === "Image"
  )
  const bottomRightIsImage = bottomRightContent?.some(
    item => item.type === "Image"
  )

  const shortDataPointContent = isNested ? true : data?.shortDataPointContent
  const contentfulId = data?.contentfulId

  const content = {
    contentfulId,
    backgroundImages,
    overlappingContent:
      overrideForStat === true ? true : !!data?.overlappingContent,
    topLeftContent,
    topLeftIsImage,
    topLeftBackgroundColor,
    topRightContent,
    topRightIsImage,
    topRightBackgroundColor,
    bottomLeftContent,
    bottomLeftIsImage,
    bottomLeftBackgroundColor,
    bottomRightContent,
    bottomRightIsImage,
    bottomRightBackgroundColor,
    shortDataPointContent: shortDataPointContent,
  }

  return renderPaddingOrFullBleed(<TwoByTwo content={content} componentClass={`two-by-two-component`} />)
}

export default TwoByTwoConnector
